export interface Song {
  id: number;
  country: string;
  artist: string;
  title: string;
  runningOrder: number;
  imageUrl?: string;
  isAutoQualifier?: boolean;
}

export const semiFinal1Songs: Song[] = [
  {
    id: 1,
    country: "Moldova",
    artist: "Satoshi",
    title: "Viva, Moldova!",
    runningOrder: 1,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/moldovapng/Moldova-fill_size%3D800x1200-focal_point%3D1167x399-focal_size%3D482x523-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1167x399-focal_size%3D482x523-format%3Dwebp.webp",
  },
  {
    id: 2,
    country: "Sweden",
    artist: "Felicia",
    title: "My System",
    runningOrder: 2,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/felicia_69ac8624368c5_26_lizzsa7jpg/felicia_69ac8624368c5_26_lIzZSa7-fill_size%3D800x1200-focal_point%3D840x440-focal_size%3D460x535-format%3Dwebp-fill_size%3D800x1200-focal_point%3D840x440-focal_size%3D460x535-format%3Dwebp.webp",
  },
  {
    id: 3,
    country: "Croatia",
    artist: "Lelek",
    title: "Andromeda",
    runningOrder: 3,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/lelek_-croatia_-photo-by-hrt-dario-njavro_-8png/lelek_%20croatia_%20photo%20by%20hrt%20%26%20dario%20njavro_%20%20%288%29-fill_size%3D800x1200-focal_point%3D1256x584-focal_size%3D188x188-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1256x584-focal_size%3D188x188-format%3Dwebp.webp",
  },
  {
    id: 4,
    country: "Greece",
    artist: "Akylas",
    title: "Ferto",
    runningOrder: 4,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/greecejpg/Greece-fill_size%3D800x1200-focal_point%3D1241x405-focal_size%3D310x253-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1241x405-focal_size%3D310x253-format%3Dwebp.webp",
  },
  {
    id: 5,
    country: "Portugal",
    artist: "Bandidos do Cante",
    title: "Rosa",
    runningOrder: 5,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/foto-bandidos-do-cantejpg/Foto%20Bandidos%20do%20Cante-fill_size%3D800x1200-focal_point%3D1050x559-focal_size%3D333x310-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1050x559-focal_size%3D333x310-format%3Dwebp.webp",
  },
  {
    id: 6,
    country: "Georgia",
    artist: "Bzikebi",
    title: "On Replay",
    runningOrder: 6,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/georgiapng/Georgia-fill_size%3D800x1200-focal_point%3D1281x262-focal_size%3D188x188-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1281x262-focal_size%3D188x188-format%3Dwebp.webp",
  },
  {
    id: 7,
    country: "Finland",
    artist: "Linda Lampenius x\nPete Parkkonen",
    title: "Liekinheitin",
    runningOrder: 7,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/linda_lampenius_x_pete_parkkonen_music_video_still_credit_nelli_kentta_lcyg46bjpg/Linda_Lampenius_x_Pete_Parkkonen_music_video_still_Credit_Nelli_kentta_LCYG46b-fill_size%3D800x1200-focal_point%3D2546x913-focal_size%3D968x704-format%3Dwebp-fill_size%3D800x1200-focal_point%3D2546x913-focal_size%3D968x704-format%3Dwebp.webp",
  },
  {
    id: 8,
    country: "Montenegro",
    artist: "Tamara Živković",
    title: "Nova Zora",
    runningOrder: 8,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/montenegrojpg/Montenegro-fill_size%3D800x1200-focal_point%3D1378x418-focal_size%3D308x368-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1378x418-focal_size%3D308x368-format%3Dwebp.webp",
  },
  {
    id: 9,
    country: "Estonia",
    artist: "Vanilla Ninja",
    title: "Too Epic To Be True",
    runningOrder: 9,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/estoniajpg/Estonia-fill_size%3D800x1200-focal_point%3D1181x1630-focal_size%3D450x468-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1181x1630-focal_size%3D450x468-format%3Dwebp.webp",
  },
  {
    id: 10,
    country: "Israel",
    artist: "Noam Bettan",
    title: "Michelle",
    runningOrder: 10,
    imageUrl:
      "https://npr.brightspotcdn.com/dims3/default/strip/false/crop/6000x4000+0+0/resize/6000x4000!/?url=http%3A%2F%2Fnpr-brightspot.s3.amazonaws.com%2F92%2F4e%2F2f7594aa46dfa892999796c75f82%2Fgettyimages-1718540530.jpg",
  },
  {
    id: 11,
    country: "Belgium",
    artist: "Essyla",
    title: "Dancing on the Ice",
    runningOrder: 11,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/essyla-euro_l_rs_ekrztndjpg/ESSYLA%20EURO_L_RS_ekRZTnD-fill_size%3D800x1200-focal_point%3D973x526-focal_size%3D423x369-format%3Dwebp-fill_size%3D800x1200-focal_point%3D973x526-focal_size%3D423x369-format%3Dwebp.webp",
  },
  {
    id: 12,
    country: "Lithuania",
    artist: "Lion Ceccah",
    title: "Sólo Quiero Más",
    runningOrder: 12,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/lithuaniajpg/Lithuania-fill_size%3D800x1200-focal_point%3D1306x690-focal_size%3D570x459-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1306x690-focal_size%3D570x459-format%3Dwebp.webp",
  },
  {
    id: 13,
    country: "San Marino",
    artist: "Senhit",
    title: "Superstar",
    runningOrder: 13,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/san-marinojpg/San%20Marino-fill_size%3D800x1200-focal_point%3D1335x451-focal_size%3D318x413-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1335x451-focal_size%3D318x413-format%3Dwebp.webp",
  },
  {
    id: 14,
    country: "Poland",
    artist: "Alicja",
    title: "Pray",
    runningOrder: 14,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/polandjpeg/Poland-fill_size%3D800x1200-focal_point%3D1241x537-focal_size%3D422x416-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1241x537-focal_size%3D422x416-format%3Dwebp.webp",
  },
  {
    id: 15,
    country: "Serbia",
    artist: "Lavina",
    title: "Kraj Mene",
    runningOrder: 15,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/serbia-lavina-photo-5-by-natasa-stamatovicjpg/Serbia%2C%20Lavina%2C%20photo%205%20by%20Nata%C5%A1a%20Stamatovi%C4%87-fill_size%3D800x1200-focal_point%3D1905x1014-focal_size%3D345x300-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1905x1014-focal_size%3D345x300-format%3Dwebp.webp",
  },
];

export const autoQualifiersSF1: Song[] = [
  {
    id: 101,
    country: "Italy",
    artist: "Sal Da Vinci",
    title: "Per Sempre Sì",
    runningOrder: 16,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/italyjpg/Italy-fill_size%3D800x1200-focal_point%3D1410x1119-focal_size%3D732x755-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1410x1119-focal_size%3D732x755-format%3Dwebp.webp",
    isAutoQualifier: true,
  },
  {
    id: 102,
    country: "Germany",
    artist: "Sarah Engels",
    title: "Fire",
    runningOrder: 17,
    imageUrl:
      "https://storage.googleapis.com/eurovision-com.appspot.com/renditions/public/cms/germanyjpg/Germany-fill_size%3D800x1200-focal_point%3D1276x1003-focal_size%3D488x428-format%3Dwebp-fill_size%3D800x1200-focal_point%3D1276x1003-focal_size%3D488x428-format%3Dwebp.webp",
    isAutoQualifier: true,
  },
];
